import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const Sidebar = ({ role }) => {
  // User Types
  const REGULAR_ADMIN = 'REGULAR_ADMIN';
  const MANAGEMENT_ADMIN = 'MANAGEMENT_ADMIN';
  const SUPER_ADMIN = 'SUPER_ADMIN';

  const pathname = window.location.pathname;
  const pathArray = pathname.split('/').filter(Boolean);

  return (
    <div>
      <div className="sidebar -dashboard" id="vendorSidebarMenu">
        {[SUPER_ADMIN, MANAGEMENT_ADMIN, REGULAR_ADMIN].includes(role) && (
          <div className="sidebar__item ">
            <Link
              to="/"
              className={`${
                pathArray.length === 0 && '-is-active'
              } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
              <img
                width={20}
                height={20}
                src="/img/dashboard/sidebar/compass.svg"
                alt="icon"
                className="mr-15"
              />
              Dashboard
            </Link>
          </div>
        )}

        {[SUPER_ADMIN, MANAGEMENT_ADMIN, REGULAR_ADMIN].includes(role) && (
          <div className="sidebar__item ">
            <Link
              to="/tenants"
              className={`${
                pathArray[0] === 'tenants' && '-is-active'
              } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
              <img
                width={20}
                height={20}
                src="/img/dashboard/sidebar/house.svg"
                alt="icon"
                className="mr-15"
              />
              Tenant
            </Link>
          </div>
        )}

        {[SUPER_ADMIN].includes(role) && (
          <div className="sidebar__item ">
            <Link
              to="/users"
              className={`${
                pathArray[0] === 'users' && '-is-active'
              } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
              <img
                width={20}
                height={20}
                src="/img/dashboard/sidebar/booking.svg"
                alt="icon"
                className="mr-15"
              />
              Pengguna
            </Link>
          </div>
        )}

        {[SUPER_ADMIN, MANAGEMENT_ADMIN].includes(role) && (
          <div className="sidebar__item ">
            <Link
              to="/bookings"
              className={`${
                pathArray[0] === 'bookings' && '-is-active'
              } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
              <img
                width={20}
                height={20}
                src="/img/dashboard/sidebar/house.svg"
                alt="icon"
                className="mr-15"
              />
              Pesanan
            </Link>
          </div>
        )}

        {[SUPER_ADMIN, MANAGEMENT_ADMIN, REGULAR_ADMIN].includes(role) && (
          <div className="sidebar__item ">
            <Link
              to="/refund"
              className={`${
                pathArray[0] === 'refund' && '-is-active'
              } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
              <img
                width={20}
                height={20}
                src="/img/dashboard/icons/1.svg"
                alt="icon"
                className="mr-15"
              />
              Pengembalian Dana
            </Link>
          </div>
        )}

        {[SUPER_ADMIN, MANAGEMENT_ADMIN, REGULAR_ADMIN].includes(role) && (
          <div className="sidebar__item ">
            <Link
              to="/withdrawl"
              className={`${
                pathArray[0] === 'withdrawl' && '-is-active'
              } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
              <img
                width={20}
                height={20}
                src="/img/dashboard/icons/1.svg"
                alt="icon"
                className="mr-15"
              />
              Penarikan Saldo
            </Link>
          </div>
        )}

        {[SUPER_ADMIN, MANAGEMENT_ADMIN, REGULAR_ADMIN].includes(role) && (
          <div className="sidebar__item ">
            <Link
              to="/article"
              className={`${
                pathArray[0] === 'article' && '-is-active'
              } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
              <img
                width={20}
                height={20}
                src="/img/dashboard/sidebar/bookmark.svg"
                alt="icon"
                className="mr-15"
              />
              Artikel
            </Link>
          </div>
        )}

        {[SUPER_ADMIN, MANAGEMENT_ADMIN, REGULAR_ADMIN].includes(role) && (
          <div className="sidebar__item ">
            <Link
              to="/voucher"
              className={`${
                pathArray[0] === 'voucher' && '-is-active'
              } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
              <img
                width={20}
                height={20}
                src="/img/dashboard/sidebar/taxi.svg"
                alt="icon"
                className="mr-15"
              />
              Voucher
            </Link>
          </div>
        )}

        {[SUPER_ADMIN, MANAGEMENT_ADMIN].includes(role) && (
          <div className="sidebar__item ">
            <Link
              to="/refund-report"
              className={`${
                pathArray[0] === 'refund-report' && '-is-active'
              } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
              <img
                width={20}
                height={20}
                src="/img/dashboard/sidebar/booking.svg"
                alt="icon"
                className="mr-15"
              />
              Laporan Pengembalian
            </Link>
          </div>
        )}

        {[SUPER_ADMIN, MANAGEMENT_ADMIN].includes(role) && (
          <div className="sidebar__item ">
            <Link
              to="/withdrawl-report"
              className={`${
                pathArray[0] === 'withdrawl-report' && '-is-active'
              } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
              <img
                width={20}
                height={20}
                src="/img/dashboard/sidebar/booking.svg"
                alt="icon"
                className="mr-15"
              />
              Laporan Penarikan
            </Link>
          </div>
        )}

        {[SUPER_ADMIN, MANAGEMENT_ADMIN].includes(role) && (
          <div className="sidebar__item ">
            <Link
              to="/cashflow"
              className={`${
                pathArray[0] === 'cashflow' && '-is-active'
              } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
              <img
                width={20}
                height={20}
                src="/img/dashboard/sidebar/booking.svg"
                alt="icon"
                className="mr-15"
              />
              Laporan Arus Kas
            </Link>
          </div>
        )}

        {[SUPER_ADMIN, MANAGEMENT_ADMIN].includes(role) && (
          <div className="sidebar__item ">
            <Link
              to="/income"
              className={`${
                pathArray[0] === 'income' && '-is-active'
              } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
              <img
                width={20}
                height={20}
                src="/img/dashboard/sidebar/booking.svg"
                alt="icon"
                className="mr-15"
              />
              Laporan Pemasukan
            </Link>
          </div>
        )}

        {[SUPER_ADMIN, MANAGEMENT_ADMIN].includes(role) && (
          <div className="sidebar__item ">
            <Link
              to="/expense"
              className={`${
                pathArray[0] === 'expense' && '-is-active'
              } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
              <img
                width={20}
                height={20}
                src="/img/dashboard/sidebar/booking.svg"
                alt="icon"
                className="mr-15"
              />
              Laporan Pengeluaran
            </Link>
          </div>
        )}

        {[SUPER_ADMIN, MANAGEMENT_ADMIN].includes(role) && (
          <div className="sidebar__item ">
            <Link
              to="/global-config"
              className={`${
                pathArray[0] === 'global-config' && '-is-active'
              } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
              <img
                width={20}
                height={20}
                src="/img/dashboard/sidebar/gear.svg"
                alt="icon"
                className="mr-15"
              />
              Konfigurasi Global
            </Link>
          </div>
        )}

        {[SUPER_ADMIN].includes(role) && (
          <div className="sidebar__item ">
            <Link
              to="/payment-method"
              className={`${
                pathArray[0] === 'payment-method' && '-is-active'
              } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
              <img
                width={20}
                height={20}
                src="/img/dashboard/sidebar/gear.svg"
                alt="icon"
                className="mr-15"
              />
              Kanal Pembayaran
            </Link>
          </div>
        )}

        {[SUPER_ADMIN].includes(role) && (
          <div className="sidebar__item ">
            <Link
              to="/facility"
              className={`${
                pathArray[0] === 'facility' && '-is-active'
              } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
              <img
                width={20}
                height={20}
                src="/img/dashboard/sidebar/gear.svg"
                alt="icon"
                className="mr-15"
              />
              Fasilitas Tenant
            </Link>
          </div>
        )}

        {[SUPER_ADMIN].includes(role) && (
          <div className="sidebar__item ">
            <Link
              to="/province"
              className={`${
                pathArray[0] === 'province' && '-is-active'
              } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
              <img
                width={20}
                height={20}
                src="/img/dashboard/sidebar/gear.svg"
                alt="icon"
                className="mr-15"
              />
              Provinsi
            </Link>
          </div>
        )}

        {[SUPER_ADMIN].includes(role) && (
          <div className="sidebar__item ">
            <Link
              to="/city"
              className={`${
                pathArray[0] === 'city' && '-is-active'
              } sidebar__button d-flex items-center text-15 lh-1 fw-500`}>
              <img
                width={20}
                height={20}
                src="/img/dashboard/sidebar/gear.svg"
                alt="icon"
                className="mr-15"
              />
              Kab/Kota
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
